import { Component, OnInit, Input, OnDestroy, OnChanges, ViewEncapsulation, AfterViewInit, SimpleChanges } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';
import { EventVM } from 'src/app/models/event/event';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetTypeShowTypeWithBets } from 'src/app/models/bet/betsAndBetTypeShowTypeWithOnlineStatus.interface';
import { Subscription } from 'rxjs';
import { SBVDisplayType, SBVSelectionType, BetTypeNameDisplayType, EventType, ErrorLevel, BetTypeOutcomeShowType, EventStatus } from 'src/app/models/enums';
import { UtilityService } from 'src/app/services/util/utility.service';
import { SettingsService } from 'src/app/services/settings.service';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { TicketService } from 'src/app/services/ticket.service';
import { IBet } from 'src/app/models/bet/bet';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { ICacheChanges } from 'src/app/models/cacheChanges/cacheChanges.interface';
import { groupBy } from 'rxjs/operators';
import { IBetTypeGroupingTemplateItem } from 'src/app/models/betType/betTypeGroupingTemplateItem.interface';
import { ScrollService } from 'src/app/services/scroll.service';
import { LoaderService } from 'src/app/services/loader.service';
import { trigger, transition, animate, style, query } from '@angular/animations';
import { ICustomNotification } from 'src/app/models/notification/customNotification';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { NotificationService } from 'src/app/services/notification.service';
import { blinkBorderAnimation } from 'src/app/animations/blink';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
declare var SIR: any;
declare var $: any;

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  styleUrls: ['./event-detail.component.less'],
  animations: [blinkBorderAnimation],
  encapsulation: ViewEncapsulation.None
})

export class EventDetailComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  public betTypeGroups: IBetTypeGroup[] = [];
  public selectedBetTypeGroup: IBetTypeGroup = null;
  public filteredBetsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets };
  public betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets };
  public eventTypeENUM = EventType;

  // @Input()
  // showEventDetail: boolean;
  public SBVDisplayTypeEnum = SBVDisplayType;
  public SBVSelectionEnum = SBVSelectionType;
  public betTypeNameDispayTypeEnum = BetTypeNameDisplayType;
  public betTypeOutcomeShowTypeEnum = BetTypeOutcomeShowType;
  public isAnyGroupActive = true;

  private subscription: Subscription = new Subscription();
  private subscriptionClearedOnChange: Subscription = new Subscription();
  protected isMobileView: boolean;
  protected isLive = false;
  public eventStatusEnum = EventStatus;
  public languageCulture: string;
  private scrollHeight = 0;

  @Input()
  expandedEvent: EventVM;

  isStreamingShow = false;
  private betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType };

  viewConfigurations = ViewConfigurations;

  showH2Hwidget = false;
  showShortResultAndResultOnExpandLive: boolean;

  // mobile widget
  private sportIds = [1, 2, 3, 4]; // Soccer, Basketball, Ice Hockey, Tennis
  private streaminWidgetWrap;
  // private streamingWrap umjesto ovog gore zbog buttona za stream i widget
  private stickyWidget;
  private fullWidget;
  private bottomWrap;

  widgetErrorMessage = true;

  constructor(
    private eventsService: EventsService,
    private utilityService: UtilityService,
    private settingsService: SettingsService,
    private ticketService: TicketService,
    private cacheChangesService: CacheChangesService,
    private scrollService: ScrollService,
    private loaderService: LoaderService,
    private updaterService: ChangesUpdaterService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private storageService: StorageService,
    private notificationService: NotificationService) {


    this.languageCulture = LocaleHelper.cultureName[this.storageService.language];

    this.subscription.add(this.ticketService.ticketItemAddedRemoved$.subscribe((identifier) => {
      if (identifier.eventId !== this.expandedEvent.id) {
        return;
      }
      this.selectBetOutcomeFromTicket(identifier);
    }));

    this.subscription.add(this.eventsService.widgetError$.subscribe(err => {
      this.widgetErrorMessage = err;
    }));
  }

  ngOnInit(): void {
    this.isMobileView = this.utilityService.mobileView;
    this.showShortResultAndResultOnExpandLive = ViewConfigurations.showShortResultAndResultOnExpandLive;
  }

  showHideStream(betRadarEventId: number, liveStreamId: number, sportId: number){
    this.eventsService.showHideStream(betRadarEventId, liveStreamId, true, sportId);
    // window.parent.scroll(0, 0);
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if ($('.bet-menu-wrap').length > 0 && this.isMobileView) {
        $('.bet-menu-wrap').animate({ scrollLeft: 100}, 600);
        setTimeout(() => {
          $('.bet-menu-wrap').animate({ scrollLeft: 0}, 600);
        }, 600);
        clearInterval(interval);
      }
    }, 100);

    if (this.expandedEvent.isLive) {
      const interval1 = setInterval(() => {
        if ($('.streaming-widget-wrap').length > 0) {
          setTimeout(() => {
            this.showHideStream(this.expandedEvent.betRadarEventId, this.expandedEvent.liveStreamId, this.expandedEvent.sportId);
          }, 100);
          clearInterval(interval1);
        }
      }, 100);
    }

    if (this.isMobileView){
      if (document.getElementById('eventLiveDetail')){
        // versrion v2
        // document.getElementById('eventLiveDetail').addEventListener('scroll', this.scroll, true);
        // document.getElementById('bottomWrap').addEventListener('scroll', (e) => { console.log('ss'); return; }, { capture: true, passive: true });
        document.getElementById('eventLiveDetail').addEventListener('scroll', this.scrollFunction.bind(this), true);
      } else {
        // window.addEventListener('scroll', this.scroll, true); // third parameter
        window.addEventListener('scroll', this.scrollFunction.bind(this), true);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cacheChangesService.unsubscribeForEventExpanded(true);
    this.cacheChangesService.unsubscribeForEventExpanded(false);
    this.subscriptionClearedOnChange.unsubscribe();
    this.subscriptionClearedOnChange = new Subscription();
    this.settingsService.getBetTypeShowTypes().subscribe((btst) => {
      this.getBetsAndGroupsForEvent(btst);
      this.betTypeShowTypes = btst;
    });
    if (this.expandedEvent.isLive) {
      this.cacheChangesService.subscribeForEventExpanded(this.expandedEvent.id, true);
      this.subscriptionClearedOnChange.add(this.cacheChangesService.cacheUpdatedLive$.subscribe((c) => this.updateEventChanges(c)));
    } else {
      this.cacheChangesService.subscribeForEventExpanded(this.expandedEvent.id, false);
      this.subscriptionClearedOnChange.add(this.cacheChangesService.cacheUpdatedPM$.subscribe((c) => this.updateEventChanges(c)));
    }

    if (this.expandedEvent.isLive &&
      changes.expandedEvent &&
      changes.expandedEvent.previousValue &&
      changes.expandedEvent.previousValue.betRadarEventId !== changes.expandedEvent.currentValue.betRadarEventId) {
        setTimeout(() => {
          this.showHideStream(this.expandedEvent.betRadarEventId, this.expandedEvent.liveStreamId, this.expandedEvent.sportId);
        }, 50);
    }
  }

  hideDetails() {
    this.eventsService.expandEvent(this.expandedEvent);
    this.scrollService.expandEventLiveChange(false);
  }

  showStreaming() {
    this.isStreamingShow = !this.isStreamingShow;
  }

  getBetsAndGroupsForEvent(betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }) {
    this.loaderService.showHideLoader(true);
    this.selectedBetTypeGroup = null;
    this.filteredBetsAndBetTypeShowType = null;
    let betsCount = 0;
    this.betsAndBetTypeShowType = {};

    this.eventsService.getBetsAndGroups(this.expandedEvent).subscribe(betsAndGroups => {
      this.betTypeGroups = betsAndGroups.groups;

      betsAndGroups.bets.forEach((bet) => {
        // create this later outside of foreach and from bettypegrouping template items
        if (!this.betsAndBetTypeShowType[bet.betTypeId]) {
          const betTypeShowTypeWithBets: IBetTypeShowTypeWithBets =
          {
            betTypeShowType: null,
            bets: [],
            betsDictionary: {},
            isAnyBetPlayable: false,
            mostBalancedBetIndex: -1,
            isExpanded: true,
            betTypeOutrightName: ''
          };

          if (!betTypeShowTypes[bet.betTypeId]) {
            console.log('No betTypeShowType for betTypeId: ' + bet.betTypeId);
            return;
          }
          betTypeShowTypeWithBets.betTypeShowType = betTypeShowTypes[bet.betTypeId];
          this.betsAndBetTypeShowType[bet.betTypeId] = betTypeShowTypeWithBets;

        }

        bet.betOutcomes.forEach(bto => {
          bto.name = this.utilityService.getBetOutcomeNameFromBTO(bto, this.betsAndBetTypeShowType[bet.betTypeId].betTypeShowType, this.expandedEvent.homeTeam, this.expandedEvent.awayTeam, this.expandedEvent.eventType);
          bto.isSelected = this.ticketService.isOutcomeInTicket(this.expandedEvent.id, bto.id);
        });

        if (bet.isPlayable) {
          betsCount++;
        }
        this.betsAndBetTypeShowType[bet.betTypeId].bets.push(bet);
        if (this.expandedEvent.eventType === EventType.Outright) {
          this.betsAndBetTypeShowType[bet.betTypeId].betTypeOutrightName = bet.outrightName;
        }
        this.betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id] = bet;
      });

      // if (this.isMobileView && !this.isLive) {
      //   this.betTypeGroups = [this.mergeBetTypeGroupsToSingleGroup(betsAndGroups.groups)];
      // }
      this.expandedEvent.betsCount = betsCount;
      this.checkIfBetsAndOutcomesArePlayableForAllBetTypes();
      this.isAnyGroupActive = this.eventsService.setOnlineForBetTypeGroups(this.betTypeGroups, this.betsAndBetTypeShowType);


      this.selectGroup(this.betTypeGroups.find((gr) => gr.isOnline));
      this.loaderService.showHideLoader(false);
    });
  }

  mergeBetTypeGroupsToSingleGroup(groups: IBetTypeGroup[]): IBetTypeGroup {
    const mergedGroup: IBetTypeGroup = {
      id: -1,
      betTypeIds: [],
      name: 'ALL',
      betTypeGroupingTemplateItems: [],
      isSelected: false,
      isUserFavoriteButton: false,
      isOnline: true,
    };

    for (const group of groups) {
      for (const betTypeGroupingTemplateItem of group.betTypeGroupingTemplateItems) {
        if (mergedGroup.betTypeGroupingTemplateItems.findIndex((btgti) => btgti.betTypeId === betTypeGroupingTemplateItem.betTypeId) === -1) {
          const newbtgti: IBetTypeGroupingTemplateItem = {
            isSelected: false,
            betTypeId: betTypeGroupingTemplateItem.betTypeId,
            groupId: -1,
            id: betTypeGroupingTemplateItem.id,
            orderNumber: this.betTypeShowTypes[betTypeGroupingTemplateItem.betTypeId] ? this.betTypeShowTypes[betTypeGroupingTemplateItem.betTypeId].orderNumber : 9999,
            sbvExactValue: null,
            sbvSelectionType: SBVSelectionType.All,
            betTypeName: null,
            betTypeOutcomes: [],
            sbvDisplayType: SBVDisplayType.NoSbv,
            betTypeDescription: this.betTypeShowTypes[betTypeGroupingTemplateItem.betTypeId] ? this.betTypeShowTypes[betTypeGroupingTemplateItem.betTypeId].betTypeDescription : '',
            betTypeOutcomeGroupingTemplateItems: []
          };
          mergedGroup.betTypeIds.push(newbtgti.betTypeId);
          mergedGroup.betTypeGroupingTemplateItems.push(newbtgti);
        }
      }
    }

    return mergedGroup;
  }

  selectGroup(group: IBetTypeGroup) {
    if (group && !group.isSelected) {
      if (this.selectedBetTypeGroup) {
        this.selectedBetTypeGroup.isSelected = false;
      }
      group.isSelected = true;
      this.selectedBetTypeGroup = group;
      this.isAnyGroupActive = this.eventsService.setOnlineForBetTypeGroups(this.betTypeGroups, this.betsAndBetTypeShowType);
      this.filteredBetsAndBetTypeShowType = this.eventsService.getBetsAndBetTypeShowTypeForBetTypeGroup(group, this.betsAndBetTypeShowType);

      if (this.expandedEvent.isLive) {
        this.googleAnalyticsService.eventEmitter('Dodatna ponuda', 'Uživo', group.id.toString());
      } else {
        this.googleAnalyticsService.eventEmitter('Dodatna ponuda', 'Prematch', group.id.toString());
      }

      if (this.isMobileView) {

        if (ViewConfigurations.useMobileViewWithTopMenu){
          // live
          if (document.getElementById('eventLiveDetail')) {
            document.getElementById('eventLiveDetail').scroll(0, 0);
          }
          // prematch
          if (document.getElementById('betTypeWrap')) {
            document.getElementById('betTypeWrap').scroll(0, 0);
          }
        } else {
          this.scrollFix();
        }
      }
    }
  }

  toggleEventOutcome(bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
    if (!outcome) {
      return;
    }
    if (!((this.expandedEvent.isPlayable && bet.isPlayable && outcome.isPlayable) || outcome.isSelected)) {
      return;
    }
    this.ticketService.toggleEventOutcome(this.expandedEvent, bet, outcome, betTypeOutcomeName, betTypeName);
  }

  selectBetOutcomeFromTicket(identifier: ITicketItemIdentifier) {
    const betOutcome = this.findBetOutcome(identifier.betTypeId, identifier.betId, identifier.betTypeOutcomeId, identifier.betOutcomeId);
    if (betOutcome) {
      if (identifier.isAdded) {
        betOutcome.isSelected = true;
      } else {
        betOutcome.isSelected = false;
      }
    }
  }

  findBetOutcome(betTypeId: number, betId: number, betTypeOutcomeId: number, betoutcomeId: number): IBetOutcome {

    if (this.betsAndBetTypeShowType[betTypeId]) {
      const bet = this.betsAndBetTypeShowType[betTypeId].betsDictionary[betId];
      if (bet) {
        if (bet.betOutcomesDic[betTypeOutcomeId]) {
          const betOutcome = bet.betOutcomesDic[betTypeOutcomeId].find(bo => bo.id === betoutcomeId);
          if (betOutcome) {
            return betOutcome;
          }
        }
      }
    }
    return null;
  }

  scrollFix(){
    // v1
    if (document.getElementById('contentWrap')) {
      const scrollT = document.getElementById('contentWrap').scrollTop;
      document.getElementById('contentWrap').scroll(0, scrollT - 1);
      document.getElementById('contentWrap').scroll(0, scrollT);
    }
  }
  scrollFunction(event) {
    // console.log(event);
    if (event.target.classList.contains('bet-menu-wrap')){ return; }
    // if scroll inside widget disable initial scroll
    if (event.target.parentElement.className.includes('sr-')){ return; }

    if (!this.bottomWrap){
      this.bottomWrap = document.getElementById('bottomWrap');
    }

    let topInfoHeight = 0;
    if (document.querySelector('.top-wrap')) {
      const topInfo = document.querySelector('.top-wrap') as HTMLElement;
      topInfoHeight = topInfo.offsetHeight;
    }

    if (document.getElementById('streaminWidgetWrap') && document.getElementById('fullWidget') && document.getElementById('stickyWidget')){

      if (!this.streaminWidgetWrap){
        this.streaminWidgetWrap = document.getElementById('streaminWidgetWrap');
      }

      if (!this.fullWidget){
        this.fullWidget = document.getElementById('fullWidget');
      }

      if (!this.stickyWidget){
        this.stickyWidget = document.getElementById('stickyWidget');
      }


      let sportId;
      // version 2
      if (document.getElementById('eventLiveDetail')) {
        sportId = Number(document.getElementById('eventLiveDetail').dataset.sportid);
      }
      // v1
      if (document.getElementById('expandEventWrap')) {
        sportId = Number(document.getElementById('expandEventWrap').dataset.sportid);
      }

      // v1
      let headerLiveHeight = 0;
      const headerLive = document.querySelector('.events-header-live');
      if (headerLive) {
        const style = getComputedStyle(headerLive);
        // tslint:disable-next-line:radix
        headerLiveHeight = parseInt(style.height) + parseInt(style.marginTop) + parseInt(style.marginBottom);
      }
      // end

      let scrollOpacityHeight = 0;
      if (document.querySelector('.event-details.box.mb-3')) {
        // v1
        const detailHeightV1 = (document.querySelector('.event-details.box.mb-3') as HTMLElement).offsetHeight;
        scrollOpacityHeight = detailHeightV1 + headerLiveHeight - this.stickyWidget.offsetHeight - 15;
      } else {
        scrollOpacityHeight = this.streaminWidgetWrap.offsetHeight - this.stickyWidget.offsetHeight;
      }


      let positionTop;
      // let topInfoHeight = 0;
      // if (document.querySelector('.top-wrap')) {
      //   const topInfo = document.querySelector('.top-wrap') as HTMLElement;
      //   topInfoHeight = topInfo.offsetHeight;
      // }
      if (this.sportIds.includes(sportId) && (event.target.scrollHeight - event.target.clientHeight > scrollOpacityHeight)) {
        positionTop = scrollOpacityHeight - topInfoHeight - headerLiveHeight;

        if (this.fullWidget && this.stickyWidget) {
          if (event.target.scrollTop <= scrollOpacityHeight) {
            const opacityPercent = Math.round((event.target.scrollTop / scrollOpacityHeight) * 100) / 100;
            const reverseOpacityPercent = 1 - opacityPercent * 1.15;
            this.fullWidget.style.opacity = reverseOpacityPercent.toString();
            this.stickyWidget.style.opacity = opacityPercent.toString();
          } else {
            this.fullWidget.style.opacity = 0;
            this.stickyWidget.style.opacity = 1;
          }
        }

      } else {
        // v1
        if (document.querySelector('.event-details.box.mb-3')) {
          positionTop = document.getElementById('expandEventWrap').offsetHeight;
        } else {
          positionTop = this.streaminWidgetWrap.offsetHeight - topInfoHeight - headerLiveHeight;
        }

        this.fullWidget.style.opacity = 1;
        this.stickyWidget.style.opacity = 0;
      }
      // reset on scroll 0
      if (event.target.scrollTop === 0) {
        this.fullWidget.style.opacity = 1;
        this.stickyWidget.style.opacity = 0;
      }

      this.bottomWrap.style.top = -positionTop + 'px';

    } else {
      // v1
      // this.bottomWrap.style.top = topInfoHeight + 'px';
    }
  }


  scroll = (event): void => {
    // console.log(event.target.className);
    // console.log(event.target.classList.contains('ticket-body-wrap'));

    if (event.target.id === 'contentWrap' && document.getElementById('expandEventWrap')) {
      // console.log(event);
      // this.changeWidgetOnScroll(event, 'expandEventWrap', 1);
    }

    // // version v2
    // if (event.target.id === 'betTypeWrap' && document.getElementById('betTypeWrap')) {
    //   // console.log(event);
    //   this.changeWidgetOnScroll(event, 'betTypeWrap', 2);
    // }
  }

  changeWidgetOnScroll(event, elId: string, type: number): void {
    const move = 2;
    if (document.getElementById('streaminWidgetWrap')) {
      const sww = document.getElementById('streaminWidgetWrap');
      const sportIds = [1, 2, 3, 4]; // Soccer, Basketball, Ice Hockey, Tennis

      const sportId = Number(document.getElementById(elId).dataset.sportid);

      if (event.target.scrollTop < move || this.scrollHeight === 0) {
        this.scrollHeight = event.target.scrollHeight;
      }

      // console.log(this.scrollHeight);
      // console.log(this.scrollHeight - event.target.offsetHeight);

      // console.log(event.target.offsetHeight);
      // console.log(event.target.scrollTop);
      // console.log('----');
      if (type === 1) {
        if (event.target.scrollTop > move && this.scrollHeight - event.target.offsetHeight > 300 && sportIds.includes(sportId)) {
          // console.log('usoo');
          sww.classList.add('scroll');

        } else {
          sww.classList.remove('scroll');
        }

      }

      if (type === 2) {
        let eventLiveDetailHeight = 0;
        if (document.getElementById('eventLiveDetail')) {
          eventLiveDetailHeight = document.getElementById('eventLiveDetail').offsetHeight - 20 - 125;
        }
        if (event.target.scrollTop > move && this.scrollHeight > eventLiveDetailHeight && sportIds.includes(sportId)) {
          // console.log('usoo');
          sww.classList.add('scroll');

        } else {
          sww.classList.remove('scroll');
        }

      }


    }
  }

  toggleDescription(event) {
    event.currentTarget.nextElementSibling.classList.toggle('hover');
  }
  showDescription(event) {
    const desc = event.currentTarget.nextElementSibling;
    if (!desc.classList.contains('show')) {
      document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));
      desc.classList.toggle('show');
      const width = window.outerWidth - event.x - 15;
      if (this.isMobileView) {
        desc.style.maxWidth = width + 'px';

      }
    } else {
      document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));
    }
  }

  showTitle(event){
    // console.log(event.target.attributes.title.value);
    // const description = event.target.nextSibling;
    if (event.currentTarget.children.length === 1) {
      const newSpan = document.createElement('span');
      newSpan.className = 'description-title show';
      newSpan.innerText = event.currentTarget.attributes.title.value;
      const width = window.outerWidth - event.x - 15;

      if (this.isMobileView) {
        newSpan.style.maxWidth = width + 'px';

      }
      document.querySelectorAll('.description-title').forEach(e => e.remove());
      event.currentTarget.append(newSpan);

    } else {
      document.querySelectorAll('.description-title').forEach(e => e.remove());
    }

    // if (!description.className.match('show')) {
    //   const width = window.outerWidth - event.x - 15;

    //   description.innerText = event.target.attributes.title.value;
    //   description.style.width = width + 'px';
    //   document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));
    //   description.classList.toggle('show');

    // } else {
    //   document.querySelectorAll('.description-title').forEach(e => e.classList.remove('show'));

    // }


  }

  headToHeadWidget(){
    // tslint:disable:no-string-literal
    // window['SIR']('removeWidget', '#sr-widget');

    if (!this.showH2Hwidget) {
      this.eventsService.openCloseHeadToHeadWidget(this.expandedEvent.betRadarEventId);
    }
    else{
      this.eventsService.openCloseHeadToHeadWidget();
      if (window['SIR']) {
        window['SIR']('removeWidget', document.querySelector('.sr-widget'));
      }
    }
  }

  matchPreviewWidget(){
    if (!this.showH2Hwidget) {
      this.eventsService.openCloseMatchPreviewWidget(this.expandedEvent.betRadarEventId);
    }
    else{
      this.eventsService.openCloseMatchPreviewWidget();
      if (window['SIR']) {
        window['SIR']('removeWidget', document.querySelector('.sr-widget'));
      }
    }
  }


  updateEventChanges(cacheChanges: ICacheChanges) {
    if (!this.expandedEvent.isLive && this.expandedEvent.dateTime <= new Date()) {
      this.eventsService.removeExpandedEventFromOffer();
    } else {
      if (cacheChanges.changedExpandedEvent && cacheChanges.changedExpandedEvent.id === this.expandedEvent.id) {
        if (!cacheChanges.changedExpandedEvent.isInOffer) {
          if (ViewConfigurations.delayRemovingFinishedLiveEvent && this.expandedEvent.status === EventStatus.Finished) {
            this.expandedEvent.isPlayable = false;
            this.expandedEvent.isInOffer = false;
            this.expandedEvent.status = EventStatus.Finished;
            setTimeout(() => {
              this.eventsService.removeExpandedEventFromOffer();
            }, ViewConfigurations.timeToDelayRemovingFinishedLiveEvent);
          } else {
            this.eventsService.removeExpandedEventFromOffer();
          }
        }
      }
    }
    const refilterSelectedGroup = this.updaterService.updateExpandedEvent(cacheChanges, this.betsAndBetTypeShowType, this.selectedBetTypeGroup, this.expandedEvent);
    this.checkIfBetsAndOutcomesArePlayableForAllBetTypes();
    this.isAnyGroupActive = this.eventsService.setOnlineForBetTypeGroups(this.betTypeGroups, this.betsAndBetTypeShowType);
    if (refilterSelectedGroup) {
      this.filteredBetsAndBetTypeShowType = this.eventsService.getBetsAndBetTypeShowTypeForBetTypeGroup(this.selectedBetTypeGroup, this.betsAndBetTypeShowType);
    }

    if (this.selectedBetTypeGroup && !this.selectedBetTypeGroup.isOnline || !this.selectedBetTypeGroup) {
      const groupToselect = this.betTypeGroups.find(g => g.isOnline);
      if (groupToselect) {
        this.selectGroup(groupToselect);
      }
    }
  }

  checkIfBetsAndOutcomesArePlayableForAllBetTypes() {
    const betTypeIds = Object.keys(this.betsAndBetTypeShowType);
    for (const betTypeId of betTypeIds) {
      this.eventsService.setIsAnyBetPlayableForBetTypeShowTypeWithBets(this.betsAndBetTypeShowType[+betTypeId], false);
     // this.betsAndBetTypeShowType[+betTypeId].isAnyBetPlayable = false;
      // for (const bet of this.betsAndBetTypeShowType[+betTypeId].bets) {
      //   if (!bet.isInOffer || !bet.isPlayable) {
      //     continue;
      //   }
      //   for (const outcome of bet.betOutcomes) {
      //     if (outcome.isInOffer && outcome.isPlayable) {
      //       this.betsAndBetTypeShowType[+betTypeId].isAnyBetPlayable = true;
      //       break;
      //     }
      //   }
      //   if (this.betsAndBetTypeShowType[+betTypeId].isAnyBetPlayable) {
      //     break;
      //   }
      // }
    }
  }

  ngOnDestroy() {

    this.cacheChangesService.unsubscribeForEventExpanded(true);
    this.cacheChangesService.unsubscribeForEventExpanded(false);
    this.subscriptionClearedOnChange.unsubscribe();
    this.subscription.unsubscribe();

    // does not call ngOnDestroy of app-streaming-widget component
    /* eslint-disable @typescript-eslint/dot-notation */
    // tslint:disable-next-line:no-string-literal
    if (window['SIR']) {
      SIR('removeWidget', document.querySelector('.lmt-container'));
      setTimeout(() => {
        SIR('check');
      }, 800);
    }
  }
}
